import React, { useEffect, useState } from 'react';
import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { useLocation, useNavigate } from 'react-router-dom';
import Loading from '../_components/Loading';
import { answerService } from '../_services/answer.service';
import { AnswerSheet } from './AnswerSheet';
import './exam.css';
import { ScoreBoard } from './ScoreBoard';

export const ExamResult = () => {
  const location = useLocation();
  const { topicData, mode, attempt } = location.state;
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [progress, setProgress] = useState({});
  const [result, setResult] = useState('');
  const [scoreData, setScoreData] = useState([]);
  const [resultConstant, setResultContent] = useState('');
  const [viewType, setViewType] = useState(2);
  const [query, setQuery] = useState({
    pageVo: {
      pageNo: 1,
      noOfItems: 10,
    },
  });

  useEffect(() => {
    getProgress(1);
  }, []);

  const getProgress = (pageNo) => {
    setIsLoading(true);
    let queryNew = query;
    // setting mocktest id and topic id for result
    queryNew.mode = mode;
    if (mode == 3) {
      queryNew.mocktest_id = topicData?._id;
      queryNew.attempt = attempt;
    } else {
      queryNew.topic_id = topicData?._id;
    }
    queryNew.pageVo.pageNo = pageNo;
    setQuery(queryNew);
    //for checking progress from result page
    queryNew.from = 'result';

    answerService.getProgress(queryNew).then(
      (res) => {
        setIsLoading(false);
        if (res.data?.data?.length) {
          setProgress(res.data.data[0]);
          if (res.data.data[0]?.is_repeat) {
            setViewType(1);
          }
          setScoreData(res.data?.scoreBoard?.rows);
        } else {
          navigate('/');
        }
        // CALCULATE THE RESULT CONTENT ACOORDING TO PERCENTAGE
        if (res?.data?.data[0]) {
          if (res?.data.data?.[0]?.percentage >= 90) {
            setResult('Excellent!');
            setResultContent('Your performance is impressive. Sounds great!');
          } else if (res?.data.data?.[0]?.percentage >= 80) {
            setResult('Great job!');
            setResultContent(' You have got good scores');
          } else if (res?.data.data?.[0]?.percentage >= 70) {
            setResult('Good work!');
            setResultContent(' You have a solid understanding of the concepts');
          } else if (res?.data.data?.[0]?.percentage >= 60) {
            setResult('Not bad!');
            setResultContent(' You are on the right track');
          } else {
            setResult('Keep trying!');
            setResultContent(' There is room for improvement, and you can do better');
          }
        }
      },
      (err) => {
        console.log(err, 'this is error');
        setIsLoading(false);
      },
    );
  };
  return (
    <div>
      {!isLoading && (
        <div className='container resultcontainer'>
          <div className='resultbox'>
            <div className='progresscontainer'>
              <CircularProgressbar value={progress?.percentage} text={`${progress?.percentage}%`} />
            </div>
            <div className=' d-flex flex-column gap-1'>
              <div className='resulthead'>{result}</div>
              <div className='resultdesc'>{resultConstant}</div>
              <div className='d-flex justify-content-between gap-2'>
                <div className='countdata'>
                  {progress.totalquestions}
                  <div className='countlbl'>Questions</div>
                </div>
                <div className='countdata rightcount'>
                  {progress.correctanswers}
                  <div className='countlbl'>Correct</div>
                </div>
                <div className='countdata wrongcount'>
                  {progress.wronganswers}
                  <div className='countlbl'>Wrong</div>
                </div>
              </div>
            </div>
          </div>

          <div
            className='backbtn'
            onClick={() => {
              if (mode == 3) {
                navigate('/');
              } else {
                navigate(`/topiclist/${topicData?.subject_id}`);
              }
            }}
          >
            <img src='/img/arowback.png' className='backicon' /> Back to Chapters
          </div>
        </div>
      )}

      {mode == 3 && (
        <div className='container switch mt-3'>
          <div className='switchbox'>
            {progress?.is_repeat && (
              <div
                className={`switchitem ${viewType == 2 ? 'inactive' : ''}`}
                onClick={() => setViewType(1)}
              >
                AnswerSheet
              </div>
            )}
            <div
              className={`switchitem ${viewType == 1 ? 'inactive' : ''}`}
              onClick={() => setViewType(2)}
            >
              Score Board
            </div>
          </div>
          {viewType == 1 && progress?.is_repeat && <AnswerSheet mocktest_id={topicData?._id} />}
          {viewType == 2 && <ScoreBoard scoreBoard={scoreData} />}
        </div>
      )}
      {isLoading && <Loading />}
    </div>
  );
};
